import { render, staticRenderFns } from "./TelegramChatRelinkModal.vue?vue&type=template&id=0007c6e6&lang=pug&"
import script from "./TelegramChatRelinkModal.vue?vue&type=script&lang=js&"
export * from "./TelegramChatRelinkModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports